import { render } from "./BookImg.vue?vue&type=template&id=5efceab7"
import script from "./BookImg.vue?vue&type=script&lang=js"
export * from "./BookImg.vue?vue&type=script&lang=js"

import "./BookImg.vue?vue&type=style&index=0&id=5efceab7&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__